export const SET_APP_STATE = 'SET_APP_STATE';

export interface AppState {
  loading?: boolean;
  logged?: boolean;
}